var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"space-y-6 pb-4"},[(_vm.$membershipHasPermissionTo('create email messages'))?_c('BaseButton',{attrs:{"primary":"","small":""},on:{"click":_vm.handleWriteEmail}},[_vm._v(" Write Email ")]):_vm._e(),_c('EmailMessageList',{ref:"emailMessageList",attrs:{"contact":_vm.contact}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }